import { ReactComponent as Icon } from 'assets/menuWide/casinoVertical.svg'
import React from 'react'

export default function VerticalsCasinoIcon(props: any) {
  return (
    <Icon {...props} />
  )
}